import React, { useState } from "react";
import { Tooltip } from "antd";
import { RiseOutlined } from "@ant-design/icons";
import VoiceAssistantModal from "./VoiceAssistantModal";
import "./VoiceAssistantButton.scss";

interface Props {
  clientId: string;
}

export default function VoiceAssistantButton({ clientId }: Props) {
  const [open, setOpen] = useState(false);

  const isSupported =
    typeof window !== "undefined" &&
    !!((window as any).SpeechRecognition || (window as any).webkitSpeechRecognition);

  if (!isSupported) return null;

  const tooltipContent = (
    <div className="va-tooltip">
      <div className="va-tooltip-title">Primjeri pitanja:</div>
      <ul>
        <li>"Zarada za februar"</li>
        <li>"Rashodi ovaj mesec lokacija NS"</li>
        <li>"Profit prošli mesec"</li>
        <li>"Satnica Marka Jovića"</li>
        <li>"Plata Ane za januar"</li>
      </ul>
      <div className="va-tooltip-hint">Kliknite da otvorite asistenta</div>
    </div>
  );

  return (
    <>
      <Tooltip title={tooltipContent} placement="bottomRight" overlayClassName="va-tooltip-overlay">
        <button
          className="va-trigger"
          onClick={() => setOpen(true)}
          aria-label="Business voice assistant"
        >
          <RiseOutlined className="va-icon" />
          <span className="va-label">Assistant</span>
        </button>
      </Tooltip>

      {open && (
        <VoiceAssistantModal
          clientId={clientId}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
